module.exports = __webpack_public_path__ + "static/img/no-img.8096b97.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/no-img.png
// module id = husR
// module chunks = 0